import React, { useEffect, useState } from 'react';
import CustomCard from '../../../components/CustomCard';
import ReservationSummary from '../details/ReservationSummary';
import { Actions } from '../../../../client/Actions';
import { useNavigate, useParams } from 'react-router-dom';
import HouseHeader from '../../../components/lakeview/HouseHeader';
import ReservationDetailsButton from '../../../components/lakeview/ReservationDetailsButton';
import DivCenter from '../../../components/div/DivCenter';
import DatesGuestsCard from '../details/DatesGuestsCard';
import { PaymentSummaryItems } from '../../../components/lakeview/payment/PaymentSummaryItems';

const BookingConfirmation = () => {
  let { id } = useParams();

  const [reservation, setReservation] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    Actions.get('reservation/' + id, setReservation);
  }, [id]);

  if (!reservation) {
    return <></>;
  }

  const { startDate, endDate } = reservation;

  return (
    <CustomCard
      title={<h2>Gratulacje 🎉</h2>}
      width={8}
      key={reservation?.id}
      shadow={false}
      className="border-0"
    >
      <h3 className="mb-4">Rezerwacja</h3>

      {reservation.houses.map((house) => (
        <HouseHeader house={house} />
      ))}


      <DatesGuestsCard reservation={reservation} />

      <ReservationSummary reservation={reservation} />

      <DivCenter>
        <ReservationDetailsButton reservationId={reservation.id} />
      </DivCenter>
    </CustomCard>
  );
};

export default BookingConfirmation;
